/**
 * Agent Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines agent-related routes.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const AgentsPage = lazy(() => import('@/features/agents/ui/pages/agents-page'));
const AgentDetailPage = lazy(() => import('@/features/agents/ui/pages/agent-detail-page'));
const AddAgentPage = lazy(() => import('@/features/agents/ui/pages/add-agent-page'));

export const agentRoutes: RouteGroup = {
  name: 'agents',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.AGENTS,
      component: AgentsPage,
      meta: {
        title: 'agents:title',
        icon: 'BriefcaseIcon',
        showInNav: true,
        navOrder: 6,
      },
    },
    {
      path: ROUTE_PATHS.AGENT_CREATE,
      component: AddAgentPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'agents:create.title',
        parent: ROUTE_PATHS.AGENTS,
      },
    },
    {
      path: ROUTE_PATHS.AGENT_DETAIL,
      component: AgentDetailPage,
      meta: {
        title: 'agents:detail.title',
        parent: ROUTE_PATHS.AGENTS,
      },
    },
    {
      path: ROUTE_PATHS.AGENT_EDIT,
      component: AgentDetailPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'agents:edit.title',
        parent: ROUTE_PATHS.AGENT_DETAIL,
      },
    },
  ],
};
